import React from 'react';
import { motion } from 'framer-motion';
const PARTNERS = [{
  name: 'Atletico Los Andes',
  country: 'Venezuela',
  flag: '🇻🇪',
  logo: 'https://cdn.magicpatterns.com/uploads/nGRn4DooZLcUz7fLUNYKmD/atletico-los-andes.png'
}, {
  name: 'Barcelona Sporting Club',
  country: 'Ecuador',
  flag: '🇪🇨',
  logo: 'https://cdn.magicpatterns.com/uploads/wkqDre2h3n5fdLZGUvvUAP/barcelona-sporting.png'
}, {
  name: 'Victorious Football Club',
  country: 'USA',
  flag: '🇺🇸',
  logo: 'https://cdn.magicpatterns.com/uploads/85PJDYRG3hYsn4qtNjxjBk/victorios-futbol-club.png'
}];
export function Partners() {
  return <section className="w-full border-t border-ink-line bg-ink-soft pt-16 sm:pt-24 pb-8" data-id="element-166" data-mp="28grhvry2rfs1">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-167" data-mp="2dg4182pqm4pv">
        <div className="text-center mb-12" data-id="element-168" data-mp="3179gogrrmuzn">
          <h2 className="font-display text-xl uppercase tracking-widest text-white/80 sm:text-2xl" data-id="element-169" data-mp="315g9n0d8q8r4">
            Our Global Network & Partners
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-10 sm:gap-16 items-center" data-id="element-170" data-mp="16qxuk0ob034q">
          {PARTNERS.map((partner, index) => <motion.div key={partner.name} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex flex-col items-center gap-4 group" data-id="element-171" data-mp="12mq1jratc10p" data-mpi={index}>
              <div className="h-24 w-24 sm:h-32 sm:w-32 flex items-center justify-center rounded-full bg-ink-card p-4 border border-ink-line shadow-lg transition-transform duration-300 group-hover:scale-105 group-hover:border-brand-orange/50" data-id="element-172" data-mp="1lfk9w2dxkuvy">
                <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-full max-w-full object-contain grayscale opacity-70 transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100" loading="lazy" data-id="element-173" data-mp="1ugibke0wcqbd" />
              </div>
              <div className="text-center" data-id="element-174" data-mp="252s6y51g2b7a">
                <p className="text-xs font-bold uppercase tracking-wide text-white/90" data-id="element-175" data-mp="253k59nmfen19">
                  {partner.name}
                </p>
                <p className="mt-1 text-[11px] font-semibold text-white/50 uppercase tracking-widest" data-id="element-176" data-mp="2e3qe2w76iyu3">
                  {partner.country} {partner.flag}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}